import { render, staticRenderFns } from "./UserEditModalHeader.vue?vue&type=template&id=14653356&scoped=true"
import script from "./UserEditModalHeader.vue?vue&type=script&lang=js"
export * from "./UserEditModalHeader.vue?vue&type=script&lang=js"
import style0 from "./UserEditModalHeader.vue?vue&type=style&index=0&id=14653356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14653356",
  null
  
)

export default component.exports